// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1IHPw","rootSmall":"AddTileButton_rootSmall__1VHan"};